export default __webpack_public_path__ + "images/xk-12d1409638442c96c8b9998dfa744c6c.svg";